export const NOTIFICATION_DIALOG_ACTIONS = {
  CLOSE: 'close',
  CANCEL: 'cancel',
  CONFIRM: 'confirm',
} as const;
